import { css } from "@emotion/react";

const wrapper = {
  base: css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    bottom: 0;
    --drawer-background: var(--color-background-primary);
  `,
  withPushContent: css`
    position: static;
    align-items: start;
    flex-grow: 1;
    width: 100%;
  `,
  withoutPushContent: css`
    z-index: 15;
    --drawer-top-offset: 0px;
  `,
  positionWithPushContent: {
    left: css`
      flex-direction: row-reverse;
    `,
    right: css`
      flex-direction: row;
    `
  },
  size: {
    small: css`
      --drawer-panel-width: 336px;

      @media (min-width: 1440px) {
        --drawer-panel-width: 376px;
      }

      @media (min-width: 1920px) {
        --drawer-panel-width: 464px;
      }
    `,
    big: css`
      --drawer-panel-width: 50%;
    `
  }
};

const DRAWER_ANIMATION_DURATION_MS = "0.15s";

const panel = {
  base: css`
    display: grid;
    grid-template-rows: auto 1fr auto;
    flex-grow: 1;
    width: var(--drawer-panel-width);
    max-height: 100vh;
    transform: translateX(var(--drawer-panel-x-offset));
    transition: all ${DRAWER_ANIMATION_DURATION_MS} ease-in-out;
    background: var(--drawer-background);
    color: var(--color-text-primary);
    animation: ${DRAWER_ANIMATION_DURATION_MS} ease-in-out forwards;
    position: sticky;
    top: var(--drawer-top-offset);
    bottom: 0;
    animation-name: kit-drawer-enter;

    @keyframes kit-drawer-enter {
      from {
        transform: translateX(var(--drawer-panel-x-offset));
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `,
  withPushContent: css`
    border-radius: var(--spacing-4);
    border-left: 1px solid var(--color-border-secondary);
    align-self: stretch;
    overflow-y: auto;
    position: sticky;
    display: flex;
    flex-direction: column;
  `,
  positionOffset: {
    left: css`
      --drawer-panel-x-offset: calc(-100% - var(--spacing-16));
    `,
    right: css`
      --drawer-panel-x-offset: calc(100% + var(--spacing-16));
    `
  },
  positionWithoutPushContent: {
    left: css`
      right: auto;
      left: 0;
      position: fixed;
    `,
    right: css`
      left: auto;
      right: 0;
      position: fixed;
    `
  }
};

const header = {
  base: css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    width: var(--drawer-panel-width);
    padding: var(--spacing-22) var(--spacing-24);
    border-bottom: 1px solid var(--color-border-secondary);
    position: sticky;
    background-color: var(--drawer-background);
    top: var(--drawer-top-offset, 0px);
    z-index: 1;
  `,
  content: css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--spacing-12);
    min-width: 0;
  `,
  title: css`
    font-size: var(--font-size-16);
    line-height: var(--spacing-18);
    font-weight: var(--font-weight-bold);
    color: var(--color-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  actions: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--spacing-16);
  `
};

const content = {
  base: css`
    max-height: var(--drawer-content-max-height, 100vh);
    transition: max-height 0.15s ease-in-out;
    height: 100%;
    width: 100%;
    position: sticky;
    flex-grow: 1;
    overflow-y: auto;
  `,
  padded: css`
    padding: var(--spacing-24);
  `,
  withPushContent: css`
    padding-top: var(--drawer-content-top-offset);
    overflow-y: unset !important;
    max-height: 100%;
  `,
  pushedContent: css`
    width: 100%;
    flex-shrink: 0;
  `,
  pushContentOpened: css`
    width: calc(100% - var(--drawer-panel-width));
    flex-shrink: unset;
  `
};

export const styles = {
  wrapper,
  panel,
  header,
  content,
  footer: css`
    padding: var(--spacing-24);
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    bottom: 0;
    background-color: var(--drawer-background);
    flex-shrink: 0;
  `,
  backdrop: css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
  `
};
